/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */

// copied from:
// https://github.ibm.com/ibmcloud/cloud-pal-community/blob/8adcdb05a31205b122067c1b649c525db8bf224d/src/components/Connected/RefResolverPicker/hooks/apiMockData/picker.js
// https://github.ibm.com/ibmcloud/cloud-pal-community/blob/8adcdb05a31205b122067c1b649c525db8bf224d/src/components/Connected/RefResolverPicker/hooks/apiMockData/secret.js

var mockData = {
  instances: [{
    id: "64c6902d-a720-4bb3-9224-53533ecc5c7b",
    name: "dev-dal-01",
    name_escaped: "dev-dal-01",
    region_id: "us-south",
    resource_group_id: "d95fd429d54158ffe80089b51353d32d",
    resource_group_name: "Default",
    resource_group_name_escaped: "Default",
    account_id: "12345678",
    provider_id: "secrets-manager"
  }, {
    id: "7c9a6ff1-2df2-468f-86d5-29aec65b7012",
    name: "dev-dal-02",
    name_escaped: "dev-dal-02",
    region_id: "us-south",
    resource_group_id: "d95fd429d54158ffe80089b51353d32d",
    resource_group_name: "Default",
    resource_group_name_escaped: "Default",
    account_id: "12345678",
    provider_id: "secrets-manager"
  }, {
    id: "8d8c1826-1ea7-4fe7-aea0-c8df095f4039",
    name: "dev-dal-03",
    name_escaped: "dev-dal-03",
    region_id: "us-south",
    resource_group_id: "d95fd429d54158ffe80089b51353d32d",
    resource_group_name: "Default",
    resource_group_name_escaped: "Default",
    account_id: "12345678",
    provider_id: "secrets-manager"
  }],
  groups: [{
    id: "default",
    name: "Default",
    name_escaped: "Default",
    account_id: "12345678",
    provider_id: "secrets-manager",
    instance_id: "64c6902d-a720-4bb3-9224-53533ecc5c7b"
  }, {
    id: "group-1",
    name: "secret-group-1",
    name_escaped: "secret-group-1",
    account_id: "12345678",
    provider_id: "secrets-manager",
    instance_id: "64c6902d-a720-4bb3-9224-53533ecc5c7b"
  }, {
    id: "group-2",
    name: "secret-group-2",
    name_escaped: "secret-group-2",
    account_id: "12345678",
    provider_id: "secrets-manager",
    instance_id: "64c6902d-a720-4bb3-9224-53533ecc5c7b"
  }, {
    id: "group-3",
    name: "secret-group-3",
    name_escaped: "secret-group-3",
    account_id: "12345678",
    provider_id: "secrets-manager",
    instance_id: "64c6902d-a720-4bb3-9224-53533ecc5c7b"
  }, {
    id: "group-4",
    name: "secret-group-4",
    name_escaped: "secret-group-4",
    account_id: "12345678",
    provider_id: "secrets-manager",
    instance_id: "64c6902d-a720-4bb3-9224-53533ecc5c7b"
  }, {
    id: "group-5",
    name: "secret-group-5",
    name_escaped: "secret-group-5",
    account_id: "12345678",
    provider_id: "secrets-manager",
    instance_id: "64c6902d-a720-4bb3-9224-53533ecc5c7b"
  }],
  types: [{
    id: "arbitrary",
    name: "Arbitrary",
    account_id: "12345678",
    provider_id: "secrets-manager",
    instance_id: "64c6902d-a720-4bb3-9224-53533ecc5c7b"
  }, {
    id: "iam_credentials",
    name: "IAM credentials",
    account_id: "12345678",
    provider_id: "secrets-manager",
    instance_id: "64c6902d-a720-4bb3-9224-53533ecc5c7b"
  }, {
    id: "kv",
    name: "Key value",
    account_id: "12345678",
    provider_id: "secrets-manager",
    instance_id: "64c6902d-a720-4bb3-9224-53533ecc5c7b"
  }],
  items: [{
    id: "e1ef8879-ac2e-2364-6cfc-5d77f9b0144a",
    name: "secret-01",
    name_escaped: "secret-01",
    group_id: "default",
    group_name: "Default",
    group_name_escaped: "Default",
    type_id: "arbitrary",
    account_id: "12345678",
    provider_id: "secrets-manager",
    instance_id: "64c6902d-a720-4bb3-9224-53533ecc5c7b"
  }, {
    id: "e1ef8879-ac2e-2364-6cfc-5d77f9b0144b",
    name: "secret-02",
    name_escaped: "secret-02",
    group_id: "default",
    group_name: "Default",
    group_name_escaped: "Default",
    type_id: "iam_credentials",
    account_id: "12345678",
    provider_id: "secrets-manager",
    instance_id: "64c6902d-a720-4bb3-9224-53533ecc5c7b"
  }, {
    id: "e1ef8879-ac2e-2364-6cfc-5d77f9b0144c",
    name: "secret-03",
    name_escaped: "secret-03",
    group_id: "default",
    group_name: "Default",
    group_name_escaped: "Default",
    type_id: "kv",
    account_id: "12345678",
    provider_id: "secrets-manager",
    instance_id: "64c6902d-a720-4bb3-9224-53533ecc5c7b"
  }],
  keys: [{
    id: "key1",
    name: "key1",
    name_escaped: "key1",
    account_id: "12345678",
    provider_id: "secrets-manager",
    instance_id: "64c6902d-a720-4bb3-9224-53533ecc5c7b",
    item_id: "e1ef8879-ac2e-2364-6cfc-5d77f9b0144b"
  }, {
    id: "key2",
    name: "key2",
    name_escaped: "key2",
    account_id: "12345678",
    provider_id: "secrets-manager",
    instance_id: "64c6902d-a720-4bb3-9224-53533ecc5c7b",
    item_id: "e1ef8879-ac2e-2364-6cfc-5d77f9b0144b"
  }, {
    id: "key3",
    name: "key3",
    name_escaped: "key3",
    account_id: "12345678",
    provider_id: "secrets-manager",
    instance_id: "64c6902d-a720-4bb3-9224-53533ecc5c7b",
    item_id: "e1ef8879-ac2e-2364-6cfc-5d77f9b0144b"
  }],
  partialTool: {
    sm_story_instance: {
      providers: [{
        type: "sm",
        region: "us-south",
        resource_group: "Default",
        instance_name: "dev-dal-02",
        integration_name: "sm-story-instance",
        groups: ["secret-group-1", "Default"]
      }]
    }
  }
};
export default mockData;